module.exports = __webpack_public_path__ + "img/overworked-employee-dark.29d13d3c.svg";